// extracted by mini-css-extract-plugin
module.exports = {"container":"List-module--container--2gAl6","list":"List-module--list--2YBzq","rotation":"List-module--rotation--16b95","pulse":"List-module--pulse--3tmoz"};